'use client';

import { c as _c } from "react/compiler-runtime";
import { Fragment } from 'react';
import { Button } from '@/app/components/button';
import { ButtonGroup } from '@/app/components/button-group';
import { DateFull } from '@/app/components/card/shared/meta/date-full';
import { Divider } from '@/app/components/divider';
import { IconArrowBack } from '@/app/components/icons/ui-actions/icon-arrow-back';
import { Container } from '@/app/components/layouts/container';
import { Section } from '@/app/components/layouts/section';
import { Image } from '@/app/components/media/image';
import { Breadcrumb, type BreadcrumbItem } from '@/app/components/navigation/breadcrumb';
import { SocialMediaShareGroup } from '@/app/components/social-media/share-group';
import { NEWS_ACTIVITIES_PAGE, NEWS_ACTIVITIES_URL } from '@/app/contents/news-activities';
import { NewsContentRow } from '@/app/lcv/components/sections/news-activities/details/content-rows';
import { DetailsContentRow } from '@/app/lcv/components/sections/news-activities/details/details-content-row';
import { DetailsGallery } from '@/app/lcv/components/sections/news-activities/details/details-gallery';
import { NewsRelated } from '@/app/lcv/components/sections/news-activities/news-related';
import { NEWS_ACTIVITIES_EVENT_NAME } from '@/app/lcv/components/sections/news-activities/tracking';
import { type NewsActivitiesDetailsProps } from '@/app/lcv/components/sections/news-activities/types';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
import { createDataGA } from '@/app/utils/createDataGA';
import { normalizeStrapiButtons } from '@/integrations/strapi/utils/button';
import { type LcvNewsDetail } from '@/types/tis-cms/types';
export interface NewsActivitiesDetailsPageProps extends NewsActivitiesDetailsProps {
  relatedData?: LcvNewsDetail[];
  testId?: string;
  eventName?: string;
}
export const NewsActivitiesDetails = t0 => {
  const $ = _c(90);
  const {
    category,
    title,
    beginDate,
    excerpt,
    heroImage,
    contentRows: t1,
    galleryTitle,
    gallery: t2,
    buttons: t3,
    backButton,
    relatedData: t4,
    testId: t5,
    eventName: t6
  } = t0;
  let T0;
  let T1;
  let relatedData;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t7;
  let t8;
  let t9;
  let testId;
  if ($[0] !== beginDate || $[1] !== category?.title || $[2] !== category?.url || $[3] !== excerpt || $[4] !== galleryTitle || $[5] !== heroImage || $[6] !== t1 || $[7] !== t2 || $[8] !== t3 || $[9] !== t4 || $[10] !== t5 || $[11] !== t6 || $[12] !== title) {
    const contentRows = t1 === undefined ? [] : t1;
    const gallery = t2 === undefined ? [] : t2;
    const buttons = t3 === undefined ? [] : t3;
    let t16;
    if ($[26] !== t4) {
      t16 = t4 === undefined ? [] : t4;
      $[26] = t4;
      $[27] = t16;
    } else {
      t16 = $[27];
    }
    relatedData = t16;
    testId = t5 === undefined ? "news-activities-details" : t5;
    const eventName = t6 === undefined ? NEWS_ACTIVITIES_EVENT_NAME : t6;
    const resolvedButtons = normalizeStrapiButtons(buttons);
    let t17;
    if ($[28] !== title) {
      t17 = image_0 => ({
        src: image_0?.url ?? "",
        alt: image_0?.alternativeText ?? title ?? "",
        width: image_0?.width ?? 0,
        height: image_0?.height ?? 0
      });
      $[28] = title;
      $[29] = t17;
    } else {
      t17 = $[29];
    }
    const galleryImages = gallery.filter(_temp).map(t17);
    let t18;
    if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
      t18 = {
        label: NEWS_ACTIVITIES_PAGE.title,
        href: NEWS_ACTIVITIES_URL
      };
      $[30] = t18;
    } else {
      t18 = $[30];
    }
    const t19 = category?.title ?? undefined;
    const t20 = `${NEWS_ACTIVITIES_URL}/${category?.url}`;
    if ($[31] !== t19 || $[32] !== t20) {
      const BREADCRUMB = [t18, {
        label: t19,
        href: t20
      }];
      t15 = <Breadcrumb links={BREADCRUMB} activeLast={true} jsonLd={false} />;
      $[31] = t19;
      $[32] = t20;
      $[33] = t15;
    } else {
      t15 = $[33];
    }
    T1 = Section;
    t12 = "md";
    t13 = "relative";
    if ($[34] !== testId) {
      t14 = createDataAttributes({
        test: testId
      });
      $[34] = testId;
      $[35] = t14;
    } else {
      t14 = $[35];
    }
    T0 = Container;
    let t21;
    if ($[36] !== title) {
      t21 = {
        __html: title
      };
      $[36] = title;
      $[37] = t21;
    } else {
      t21 = $[37];
    }
    const t22 = `${testId}-title`;
    let t23;
    if ($[38] !== t22) {
      t23 = createDataAttributes({
        test: t22
      });
      $[38] = t22;
      $[39] = t23;
    } else {
      t23 = $[39];
    }
    let t24;
    if ($[40] !== t21 || $[41] !== t23) {
      t24 = <h1 className="font-noto-bold text-sub-h1 where-span:text-inline-wrap" dangerouslySetInnerHTML={t21} {...t23} />;
      $[40] = t21;
      $[41] = t23;
      $[42] = t24;
    } else {
      t24 = $[42];
    }
    let t25;
    if ($[43] !== beginDate) {
      t25 = !!beginDate && <DateFull date={{
        startDate: beginDate as string
      }} className="text-body-1 mt-4 text-gray-700" />;
      $[43] = beginDate;
      $[44] = t25;
    } else {
      t25 = $[44];
    }
    let t26;
    if ($[45] !== excerpt) {
      t26 = !!excerpt?.textContent && <div className="text-sub-h2 mt-4 text-gray-700" dangerouslySetInnerHTML={{
        __html: excerpt.textContent
      }} />;
      $[45] = excerpt;
      $[46] = t26;
    } else {
      t26 = $[46];
    }
    if ($[47] !== t24 || $[48] !== t25 || $[49] !== t26) {
      t7 = <DetailsContentRow contentClassName="lg:col-start-2 lg:col-span-10">{t24}{t25}{t26}</DetailsContentRow>;
      $[47] = t24;
      $[48] = t25;
      $[49] = t26;
      $[50] = t7;
    } else {
      t7 = $[50];
    }
    if ($[51] !== heroImage || $[52] !== testId || $[53] !== title) {
      t8 = !!heroImage?.url && <DetailsContentRow contentClassName={cn("col-span-12 col-start-1 md:col-span-8 md:col-start-3 xl:col-span-6 xl:col-start-4", {
        "md:col-start-2 lg:col-span-10 lg:col-start-2 xl:col-span-10 xl:col-start-2": (heroImage.width ?? 0) > (heroImage.height ?? 0)
      })}><figure className={cn("bg-silver-50 lg:after-overlay rounded-base-md relative block size-full overflow-hidden")} {...createDataAttributes({
          test: `${testId}-image-detail`
        })}><Image priority={true} src={heroImage.url} alt={heroImage.alternativeText ?? title} width={heroImage.width as number} height={heroImage.height as number} layout="ratio" aspectRatio="calculate" sizes="(min-width: 1024px) 640px, 100vw" /></figure></DetailsContentRow>;
      $[51] = heroImage;
      $[52] = testId;
      $[53] = title;
      $[54] = t8;
    } else {
      t8 = $[54];
    }
    let t27;
    if ($[55] !== testId || $[56] !== title) {
      t27 = (row_0, index) => <Fragment key={`content-row-${index}`}><NewsContentRow data={row_0} title={title} index={index} testId={testId} /></Fragment>;
      $[55] = testId;
      $[56] = title;
      $[57] = t27;
    } else {
      t27 = $[57];
    }
    t9 = (contentRows ?? []).filter(_temp2).map(t27);
    if ($[58] !== galleryImages || $[59] !== galleryTitle || $[60] !== testId) {
      t10 = galleryImages.length > 0 && <DetailsContentRow><DetailsGallery images={galleryImages} title={galleryTitle ?? undefined} testId={`${testId}-gallery`} /></DetailsContentRow>;
      $[58] = galleryImages;
      $[59] = galleryTitle;
      $[60] = testId;
      $[61] = t10;
    } else {
      t10 = $[61];
    }
    t11 = resolvedButtons.length > 0 && <DetailsContentRow><ButtonGroup className="justify-center">{resolvedButtons.map((button, index_0) => <Button key={index_0} color="red" href={button.url} target={button.target} variant="primary" {...createDataAttributes({
          test: `${testId}-button-${index_0}`
        })} {...createDataGA({
          click: true,
          text: button.label,
          eventName,
          url: button.url
        })}>{button.label}</Button>)}</ButtonGroup></DetailsContentRow>;
    $[0] = beginDate;
    $[1] = category?.title;
    $[2] = category?.url;
    $[3] = excerpt;
    $[4] = galleryTitle;
    $[5] = heroImage;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
    $[12] = title;
    $[13] = T0;
    $[14] = T1;
    $[15] = relatedData;
    $[16] = t10;
    $[17] = t11;
    $[18] = t12;
    $[19] = t13;
    $[20] = t14;
    $[21] = t15;
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
    $[25] = testId;
  } else {
    T0 = $[13];
    T1 = $[14];
    relatedData = $[15];
    t10 = $[16];
    t11 = $[17];
    t12 = $[18];
    t13 = $[19];
    t14 = $[20];
    t15 = $[21];
    t7 = $[22];
    t8 = $[23];
    t9 = $[24];
    testId = $[25];
  }
  let t16;
  if ($[62] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <SocialMediaShareGroup theme="light" className="shrink-0" />;
    $[62] = t16;
  } else {
    t16 = $[62];
  }
  let t17;
  if ($[63] !== backButton || $[64] !== testId) {
    t17 = !!backButton && !!backButton.href && <Button href={backButton.href} variant="secondary" color="black" iconBefore={<IconArrowBack />} width="auto" {...createDataAttributes({
      test: `${testId}-back-button`
    })}>{backButton.children}</Button>;
    $[63] = backButton;
    $[64] = testId;
    $[65] = t17;
  } else {
    t17 = $[65];
  }
  let t18;
  if ($[66] !== t17) {
    t18 = <DetailsContentRow contentClassName="flex flex-col items-center gap-y-12">{t16}{t17}</DetailsContentRow>;
    $[66] = t17;
    $[67] = t18;
  } else {
    t18 = $[67];
  }
  let t19;
  if ($[68] !== t10 || $[69] !== t11 || $[70] !== t18 || $[71] !== t7 || $[72] !== t8 || $[73] !== t9) {
    t19 = <article>{t7}{t8}{t9}{t10}{t11}{t18}</article>;
    $[68] = t10;
    $[69] = t11;
    $[70] = t18;
    $[71] = t7;
    $[72] = t8;
    $[73] = t9;
    $[74] = t19;
  } else {
    t19 = $[74];
  }
  let t20;
  if ($[75] !== relatedData) {
    t20 = relatedData?.length > 0 && <><Divider size="2xl" className="my-12 xl:my-16" {...createDataAttributes({
        test: "divider"
      })} /><NewsRelated data={relatedData} /></>;
    $[75] = relatedData;
    $[76] = t20;
  } else {
    t20 = $[76];
  }
  let t21;
  if ($[77] !== T0 || $[78] !== t19 || $[79] !== t20) {
    t21 = <T0>{t19}{t20}</T0>;
    $[77] = T0;
    $[78] = t19;
    $[79] = t20;
    $[80] = t21;
  } else {
    t21 = $[80];
  }
  let t22;
  if ($[81] !== T1 || $[82] !== t12 || $[83] !== t13 || $[84] !== t14 || $[85] !== t21) {
    t22 = <T1 size={t12} className={t13} {...t14}>{t21}</T1>;
    $[81] = T1;
    $[82] = t12;
    $[83] = t13;
    $[84] = t14;
    $[85] = t21;
    $[86] = t22;
  } else {
    t22 = $[86];
  }
  let t23;
  if ($[87] !== t15 || $[88] !== t22) {
    t23 = <>{t15}{t22}</>;
    $[87] = t15;
    $[88] = t22;
    $[89] = t23;
  } else {
    t23 = $[89];
  }
  return t23;
};
function _temp(image) {
  return image?.url;
}
function _temp2(row) {
  return !!row;
}